import React from 'react';
import { usePurchasedTitles, useSubscribedProducts } from '../../../../../queries/ats/me/products/hooks';
import { useSectionItems } from '../../../../../queries/ats/layout/queries';
import { Layout } from '../../../../../queries/ats/layout/types';
import { PersonalizedSwimlane } from './personalized-swimlane';
import { Swimlane } from '../../../../../components/Swimlane/Swimlane';
import { PatternHandler } from '../../../PatternHandler';

interface SectionBoughtProps {
  view: Layout.SectionView;
  pageStyle: 'grid' | 'swimlane';
}

export function SectionBought({ view, pageStyle }: SectionBoughtProps) {
  const { data: titles, isLoading: isLoadingTitles, isFetching: isFetchingTitles } = usePurchasedTitles();
  const { data: products, isLoading: isLoadingProducts, isFetching: isFetchingProducts } = useSubscribedProducts();
  const { data: items, isLoading: isLoadingItems } = useSectionItems({ link: view.link });

  const isLoading = isLoadingTitles || isLoadingProducts || isLoadingItems;
  const isFetching = isFetchingTitles || isFetchingProducts;

  if (isLoading) {
    return (
      <Swimlane>
        <Swimlane.Header>
          <Swimlane.Title>{view.label}</Swimlane.Title>
          <Swimlane.Buttons />
        </Swimlane.Header>
        <Swimlane.Slider>
          {Array.from({ length: 10 }).map((_, index) => (
            <PatternHandler.Skeleton pattern={view.style.pattern} key={index} />
          ))}
        </Swimlane.Slider>
      </Swimlane>
    );
  }

  if (titles === undefined || products === undefined || items === undefined) {
    throw new Error('Titles and products should be defined');
  }

  return (
    <PersonalizedSwimlane
      view={view}
      items={items}
      titles={titles}
      products={products}
      isFetching={isFetching}
      pageStyle={pageStyle}
    />
  );
}
